import { create, UseBoundStore } from 'zustand';

import { AuthStatus } from 'scbk-services/auth/constants';
import _ from 'scbk-services/utils/lodash-extension.ts';

import type { StoreApi } from 'zustand';

interface AuthStatusState {
    status: AuthStatus;
    getAuthStatus: () => AuthStatus;
    setAuthStatus: (status: AuthStatus) => void;
    resetAuthStatus: () => void;
}

let storeInstance: UseBoundStore<StoreApi<AuthStatusState>> | null = null;

const createStore = () =>
    create<AuthStatusState>((set, get) => ({
        status: AuthStatus.UNAUTHENTICATED,
        getAuthStatus: () => get().status,
        setAuthStatus: (status: AuthStatus) => set({ status }),
        resetAuthStatus: () => set({ status: AuthStatus.UNAUTHENTICATED }),
    }));

const useAuthStatusStore = (() => {
    if (_.isEmpty(storeInstance)) {
        storeInstance = createStore();
    }

    return storeInstance!;
})();

export { useAuthStatusStore };
